// resetを入れるとリンクの色がついてしまうのでresetしない(resetが特殊処理)

// import 'antd/dist/reset.css'
import '../assets/styles/antd.less'
import './styles.css'
import '../assets/styles/external.less'
import '../assets/styles/transition.less'
import '../assets/styles/main.less'

import BugsnagPerformance from '@bugsnag/browser-performance'
import { HoneycombWebSDK, WebVitalsInstrumentation } from '@honeycombio/opentelemetry-web'
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web'
import { APP_CONFIG, VERSION } from '@salescore/buff-common'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import dayjs from 'dayjs'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import reportWebVitals from './reportWebVitals.ts'
// Import the generated route tree
import { routeTree } from './routeTree.gen.ts'

const bugsnagApiKey = process.env.BUGSNAG_API_KEY

dayjs.locale('ja')

if (bugsnagApiKey !== undefined) {
  BugsnagPerformance.start({
    apiKey: bugsnagApiKey,
  })
}

// Honeycomb.io -- https://docs.honeycomb.io/send-data/javascript-browser
if (process.env.HONEYCOMB_API_KEY !== undefined) {
  const sdk = new HoneycombWebSDK({
    debug: false,
    apiKey: process.env.HONEYCOMB_API_KEY,
    serviceName: 'client',
    resourceAttributes: {
      'app.version': VERSION,
    },
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-document-load': {
          enabled: true,
        },
      }),
      new WebVitalsInstrumentation(),
    ], // Adds automatic instrumentation
    sampleRate: APP_CONFIG.HONEYCOMB_SAMPLE_RATE,
  })
  sdk.start()
}

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Render the app
const rootElement = document.querySelector('#app')
if (rootElement?.innerHTML === '') {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  )
}

// eslint-disable-next-line sonarjs/todo-tag
// TODO: Honeycombと統合する
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
